import request from 'superagent';

export async function getJson (mapId) {
  const url = `https://caltopo.com/m/${mapId}`;
  const res = await request.get(url);

  return {
    metaData: parseMetaData(res.text),
    mapData: parseMapData(res.text)
  };
}

export function parseMetaData (html) {
  const match = /sarsoft=(.+)$/m.exec(html);
  if (!match) throw Error('Unable to parse meta data JSON.');
  return JSON.parse(match[1]);
}


export function parseMapData (html) {
  const match = /org\.sarsoft\.preload = (.+);$/m.exec(html);
  if (!match) throw Error('Unable to parse map data JSON.');
  return JSON.parse(match[1]);
}

export default getJson;
